import {z} from "zod"
import {Frequency} from "@indebted/payment-arrangement/Slider/Frequency"

import {postJson} from "../http"

const PostSetupResponseSchema = z.looseObject({
	Next: z.string().nonempty(),
})

export type PostSetupResponse = z.infer<typeof PostSetupResponseSchema>

export async function postSetup({
	paymentArrangementID,
	frequency,
	startDate,
	numberOfPayments,
}: {
	paymentArrangementID: string
	frequency: Frequency
	startDate: Date
	numberOfPayments: number
}): Promise<PostSetupResponse> {
	const data = await postJson(`/app/payment-arrangements/${paymentArrangementID}/setup`, PostSetupResponseSchema, {
		Frequency: frequency,
		StartDate: startDate,
		NumberOfDebits: numberOfPayments,
	})
	return data
}
